import { useEffect } from 'react';
import { useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { CanvasOptions } from '~/constants/Canvas';

interface CharacterProps {
  id: string;
  url: string;
}

export default function Character({ id, url }: CharacterProps) {
  const { scene } = useLoader(GLTFLoader, url);

  useEffect(() => {
    if (!scene) return;

    scene.traverse((child) => {
      // @ts-ignore
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
        // @ts-ignore
        child.material.transparent = false;
      }
    });
  }, [scene]);

  useEffect(() => {
    return () => {
      useLoader.clear(GLTFLoader, url);
    };
  }, [url, id]);

  return (
    <>
      {scene && (
        <primitive
          key={id}
          object={scene}
          position={CanvasOptions.asset.characterPosition}
        />
      )}
    </>
  );
}
